import React, { FC } from 'react';

import type { ImmutableTrip } from 'src/types/trips/Trips';
import Dropdown from 'src/common/components/Dropdown';
import ToggleButton from 'src/common/components/ToggleButton';
import { userIsRenter } from 'src/inbox/helpers';
import TripDetails from '../TripDetails';

import s from './DetailsDropdown.module.scss';

type DetailsDropdownProps = {
  trip: ImmutableTrip;
};

const DetailsDropdown: FC<DetailsDropdownProps> = ({ trip }) => {
  const isRenter = userIsRenter(trip);
  return (
    <Dropdown className={s.root}>
      {({ isOpen, toggle }) => (
        <>
          <ToggleButton
            onClick={toggle}
            isOpen={isOpen}
            classNameModifier="centered"
          >
            Trip Details
          </ToggleButton>
          {isOpen && (
            <TripDetails
              trip={trip}
              withTooltips={false}
              withAddons={!isRenter}
            />
          )}
        </>
      )}
    </Dropdown>
  );
};

export default DetailsDropdown;
